import axios from './axios';

export const deviceTypesAPI = {
  getAll: async () => {
    const response = await axios.get('/device-types/');
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`/device-types/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post('/device-types/', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`/device-types/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`/device-types/${id}`);
    return response.data;
  },

  uploadImage: async (id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`/device-types/${id}/image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  deleteImage: async (id) => {
    const response = await axios.delete(`/device-types/${id}/image`);
    return response.data;
  },

  addCharacteristic: async (id, characteristicData) => {
    const response = await axios.post(`/device-types/${id}/characteristics`, characteristicData);
    return response.data;
  },

  updateCharacteristic: async (id, characteristicId, characteristicData) => {
    const response = await axios.put(`/device-types/${id}/characteristics/${characteristicId}`, characteristicData);
    return response.data;
  },

  removeCharacteristic: async (id, characteristicId) => {
    const response = await axios.delete(`/device-types/${id}/characteristics/${characteristicId}`);
    return response.data;
  }
};
